import { TransactionCategoryApi } from "../api";

export class TransactionCategory {
  constructor(data) {
    for (const [key, value] of Object.entries(data)) {
      this[key] = value;
    }
  }
  static async createTransactionCategory(formData) {
    const { data } = await TransactionCategoryApi.createTransactionCategory(formData);
    return new TransactionCategory(data.result);
  }
  static async getTransactionCategoryByProject(formData) {
    const { data } = await TransactionCategoryApi.getTransactionCategoryByProject(formData);
    return data.result.map(item => new TransactionCategory(item));
  }
  static async removeTransactionCategory(id) {
    const { data } = await TransactionCategoryApi.removeTransactionCategory(id);
    return data
  }
  static async updateTransactionCategory(formData) {
    const { data } = await TransactionCategoryApi.updateTransactionCategory(formData);
    return new TransactionCategory(data.result);
  }
}